import { Navigate,Outlet  } from 'react-router-dom';
import { useAuth, type Rol } from '@/hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  roles?: Rol[];
}

export default function ProtectedRoute({ children, roles }: ProtectedRouteProps) {
  const { usuario,cargando} = useAuth();

    if (cargando) {
    return (
      <div className="flex justify-center items-center h-screen">
        <i className="ri-loader-4-line animate-spin text-2xl text-foreground-400"></i>
      </div>
    );
  }

  if (!usuario) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(usuario.rol)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}